
import { createSlice } from "@reduxjs/toolkit";
import { IFabrixIcons } from "../types";
import { createUUID } from "../common";



export interface UXManagementState {
    [key: string]: any;
}


export const initUxManagementState: UXManagementState = {

}

const UxManagementSlice = createSlice({
    name: 'ux',
    initialState: initUxManagementState,
    reducers: {
        setUXManagement(state, action) {
            let eventName = action.payload.eventName;
            state[eventName] = {...state[eventName], ...action.payload.eventData};
        },
        clearUXManagement(state, action) {
            let eventName = action.payload.eventName;
            let eventData = state[eventName]
            if (eventData)
                state[eventName] = undefined;
        }

    },
    extraReducers: (builder) => {
    }
});

export const { setUXManagement, clearUXManagement } = UxManagementSlice.actions;
export default UxManagementSlice.reducer;